<template lang="pug">
shListData(title="Artículos" resolver="articles" keyData="article" component="shArticle")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Articles',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/article/Articles.vue